export default {
  title: 'Offerta sovrapposta nello stesso periodo',
  buttons: {
    save_as_active: 'Imposta come nuova offerta attiva',
    save_as_inactive: 'Salva come inattiva',
    cancel: 'Annulla',
  },
  description: {
    base: "{{offer}} si sovrappone all'offerta attiva {{overlappingOffer}} il {{weekday}}{{between}}. È possibile avere una sola offerta attiva nello stesso periodo.",
    between: ', tra {{start}}-{{end}}',
  },
  how_to_resolve: {
    title: "Come risolvere: Scegli un'opzione qui sotto.",
  },
};
